const binding = { modules: {}, dataActions: {} };

    (binding.modules['moe-tile-list-description-only'] = {
        c: () => require('partner/modules/moe-tile-list-description-only/moe-tile-list-description-only.tsx'),
        $type: 'containerModule',
        da: [],
        
        iNM: false,
        ns: '__local__',
        n: 'moe-tile-list-description-only',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/moe-tile-list-description-only'
    });
        

        
    window.__bindings__ = window.__bindings__ || {};
    window.__bindings__.modules = {
        ...window.__bindings__.modules || {},
        ...binding.modules
    };
    
        window.__bindings__.dataActions = {
        ...window.__bindings__.dataActions || {},
        ...binding.dataActions
    };
                        export const viewDictionary = {};
                        viewDictionary['__local__|__local__|modules|moe-tile-list-description-only|moe-tile-list-description-only'] = {
                c: () => require('partner/modules/moe-tile-list-description-only/moe-tile-list-description-only.view.tsx'),
                cn: '__local__-__local__-moe-tile-list-description-only'
            };
window.__bindings__ = window.__bindings__ || {};
window.__bindings__.viewDictionary = {
                        ...window.__bindings__.viewDictionary || {},
                        ...viewDictionary
                    };